import { render, staticRenderFns } from "./DHSchemaTrack.vue?vue&type=template&id=215213d0&scoped=true"
import script from "./DHSchemaTrack.vue?vue&type=script&lang=js"
export * from "./DHSchemaTrack.vue?vue&type=script&lang=js"
import style0 from "./DHSchemaTrack.vue?vue&type=style&index=0&id=215213d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215213d0",
  null
  
)

export default component.exports